// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"e923b6cd2e3063c6","5285":"427aa5d5ac52e642"}[chunkId] + ".css";
};